// extracted by mini-css-extract-plugin
module.exports = {"limited":"ProductAvailability__limited___yvQ9I"};